var _path, _path2, _path3, _rect, _path4, _path5, _path6, _rect2, _rect3, _rect4, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _rect5, _rect6, _rect7, _circle, _circle2, _path14, _rect8, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIllErrorstyled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 343,
    height: 343,
    viewBox: "0 0 343 343",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M153 214L180 157.5",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M289.837 109.721C309.817 151.401 339.525 259.923 228.704 257.761C139.437 256.02 99.3659 316.262 59.2749 254.457C36.1961 218.878 38.0942 124.504 148.516 68.9753C234.656 25.6579 276.655 82.2219 289.837 109.721Z",
    fill: "var(--color-theme_clubNavigation1, var(--color-theme_clubNavigation1-override, rgba(51,51,51,1)))",
    fillOpacity: 0.1
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M82.6713 74.468C77.0505 76.0687 71.1963 72.8098 69.5956 67.1891C69.5095 66.8867 69.198 66.7009 68.8956 66.7871L65.7184 67.6919C63.7645 68.2484 62.6315 70.2835 63.188 72.2375L102.004 208.535C102.058 209.022 102.153 209.512 102.292 210L109.558 235.513C109.995 237.048 111.593 237.938 113.128 237.501L115.506 236.824C115.807 236.738 115.973 236.418 115.887 236.117C114.287 230.496 117.545 224.642 123.166 223.041C128.787 221.44 134.641 224.699 136.242 230.32C136.327 230.621 136.637 230.806 136.938 230.72L143.264 228.918C143.565 228.833 143.731 228.513 143.645 228.213C142.044 222.592 145.303 216.738 150.924 215.137C156.545 213.536 162.399 216.795 164 222.416C164.085 222.716 164.395 222.901 164.695 222.815L171.019 221.014C171.32 220.929 171.486 220.608 171.4 220.307C169.799 214.687 173.058 208.832 178.679 207.232C184.3 205.631 190.154 208.89 191.755 214.511C191.84 214.812 192.15 214.996 192.451 214.911L195.631 214.005C197.585 213.449 198.718 211.413 198.161 209.459L192.583 189.871C192.529 189.383 192.434 188.893 192.295 188.405L151.792 46.1831C151.355 44.6486 149.756 43.7589 148.222 44.1959L145.846 44.8724C145.544 44.9585 145.377 45.2806 145.463 45.583C147.064 51.2038 143.805 57.058 138.184 58.6587C132.563 60.2594 126.709 57.0005 125.109 51.3798C125.022 51.0773 124.711 50.8915 124.408 50.9777L118.089 52.7773C117.787 52.8633 117.62 53.1851 117.706 53.4872C119.307 59.108 116.048 64.9622 110.427 66.5629C104.807 68.1636 98.9525 64.9047 97.3518 59.284C97.2658 58.9818 96.9545 58.7962 96.6523 58.8823L90.3333 60.6818C90.0309 60.768 89.8641 61.0899 89.9502 61.3923C91.5509 67.0131 88.292 72.8673 82.6713 74.468Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 73.7061,
    y: 83.2804,
    width: 79.1595,
    height: 142.081,
    rx: 8,
    transform: "rotate(-15.8464 73.7061 83.2804)",
    fill: "white",
    stroke: "black",
    strokeWidth: 2
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M116.259 181.163L164.178 167.517",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M120.628 196.557L168.547 182.912",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M113.53 190.132L171.866 173.52",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 93.5646,
    y: 152.432,
    width: 78.7457,
    height: 20.1442,
    transform: "rotate(-15.8464 93.5646 152.432)",
    stroke: "black",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 93.2178,
    y: 95.1221,
    width: 53.7879,
    height: 53.7879,
    rx: 26.8939,
    transform: "rotate(-15.8963 93.2178 95.1221)",
    fill: "black"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88.483,
    y: 90.7396,
    width: 53.7879,
    height: 53.7879,
    rx: 26.8939,
    transform: "rotate(-15.8963 88.483 90.7396)",
    stroke: "black",
    strokeWidth: 2
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M134.419 117.568C133.51 116.418 132.383 115.459 131.103 114.745C129.822 114.03 128.414 113.575 126.958 113.406C125.502 113.236 124.026 113.354 122.616 113.755C121.206 114.155 119.888 114.829 118.738 115.739C117.588 116.648 116.629 117.775 115.915 119.056C115.201 120.336 114.746 121.744 114.576 123.2",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M103.439 104.978L114.715 106.719L106.035 114.125",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M136.8 105.392L125.524 103.651L134.203 96.2455",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M219.018 118.201C213.736 115.699 211.484 109.388 213.987 104.107C214.121 103.823 214.01 103.479 213.726 103.344L210.74 101.929C208.905 101.059 206.711 101.842 205.841 103.678L145.155 231.735C144.872 232.14 144.618 232.573 144.4 233.034L133.04 257.006C132.356 258.448 132.971 260.171 134.413 260.854L136.647 261.913C136.93 262.047 137.267 261.916 137.401 261.632C139.904 256.351 146.214 254.099 151.496 256.602C156.777 259.104 159.029 265.415 156.526 270.696C156.392 270.979 156.503 271.323 156.787 271.457L162.727 274.272C163.01 274.406 163.347 274.275 163.481 273.992C165.984 268.711 172.294 266.459 177.575 268.961C182.856 271.464 185.109 277.774 182.606 283.056C182.472 283.338 182.583 283.682 182.866 283.816L188.807 286.632C189.09 286.766 189.426 286.634 189.56 286.351C192.063 281.07 198.373 278.818 203.655 281.32C208.936 283.823 211.188 290.133 208.685 295.415C208.551 295.698 208.663 296.041 208.945 296.175L211.932 297.591C213.768 298.461 215.962 297.678 216.832 295.842L225.551 277.444C225.834 277.039 226.087 276.606 226.306 276.145L289.634 142.514C290.317 141.072 289.702 139.349 288.26 138.666L286.027 137.608C285.744 137.473 285.407 137.605 285.272 137.889C282.769 143.17 276.459 145.422 271.178 142.919C265.897 140.417 263.644 134.107 266.147 128.825C266.282 128.542 266.17 128.198 265.887 128.063L259.947 125.248C259.663 125.114 259.326 125.246 259.191 125.529C256.689 130.81 250.378 133.063 245.097 130.56C239.816 128.057 237.564 121.747 240.066 116.466C240.201 116.182 240.089 115.838 239.806 115.703L233.868 112.889C233.584 112.755 233.246 112.887 233.112 113.171C230.609 118.452 224.299 120.704 219.018 118.201Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M173.916 220.565L218.939 241.903",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M167.05 235.019L212.074 256.357",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M165.95 225.509L220.761 251.485",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 175.798,
    y: 184.001,
    width: 78.7457,
    height: 20.1442,
    transform: "rotate(25.4063 175.798 184.001)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.1,
    x: 218.797,
    y: 137.779,
    width: 53.7879,
    height: 53.7879,
    rx: 26.8939,
    transform: "rotate(25.3564 218.797 137.779)",
    fill: "black"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 212.656,
    y: 134.269,
    width: 53.7879,
    height: 53.7879,
    rx: 26.8939,
    transform: "rotate(25.3564 212.656 134.269)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 4.05946,
    transform: "matrix(0.903288 0.429035 -0.429034 0.903288 216.783 158.698)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4.05946,
    transform: "matrix(0.903288 0.429035 -0.429034 0.903288 239.782 169.235)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M229.503 184.728C229.578 183.264 229.363 181.799 228.871 180.418C228.379 179.037 227.621 177.766 226.638 176.678C225.655 175.591 224.468 174.707 223.144 174.078C221.819 173.449 220.384 173.087 218.92 173.013C217.456 172.938 215.991 173.153 214.61 173.645C213.229 174.136 211.958 174.895 210.871 175.878",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 206.466,
    y: 118.917,
    width: 79.1596,
    height: 142.081,
    rx: 8,
    transform: "rotate(25.4063 206.466 118.917)",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M151.589 213.891L180.346 152.192",
    stroke: "black",
    strokeWidth: 4,
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllErrorstyled);
export default __webpack_public_path__ + "static/media/ill-error.styled.2f5eafd9.svg";
export { ForwardRef as ReactComponent };